import React from "react";
import IconClose from "../Resources/svg/Icons/IconClose";
import ModalFiltering from "./FormElements/ModalFiltering";
import Button from "./FormElements/Button";

const ModalAlertSendEmail = ({
  openModal,
  setOpenModal,
  handleClose
}) => {
  const closeModal = () => {
    setOpenModal(false);
    handleClose();
  }
  return (
    <ModalFiltering
      className={`modal-result is-midle ${
        openModal && "is-open"
      }`}
    >
      <div
        className="modal-filtering__close"
        onClick={() => closeModal()}
      >
        <IconClose />
      </div>
      <h2 className="modal-result__title">Enviando a BackOffice</h2>
      <div className="modal-result__desc">
        <p>Los datos de la simulación y del asegurado se han enviado satisfactoriamente</p>
      </div>
      <div className="actions">
        <Button
          type="submit"
          className="actions__continue"
          onClick={() => closeModal()}
        >
          Aceptar
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default ModalAlertSendEmail;
